import useSWR from 'swr'
import { getUserIntercomHash } from '../../legacy-api/user/api'
import { buildCacheKey } from '../../shared/utils/cache'
import { getMe } from './api'

const getMeAndIntercomHash = async ({ token }: { token: string }) => {
  if (!token) return null
  const [user, intercomHash] = await Promise.all([getMe({ token }), getUserIntercomHash({ token })])
  return { ...user, intercomUserHash: intercomHash }
}

export const useYourUserData = (params?: { token?: string }) => {
  const cacheKey = buildCacheKey('useYourUserData', { token: params?.token })
  const {
    data,
    isLoading,
    error,
    mutate: refresh
  } = useSWR(cacheKey, getMeAndIntercomHash, {
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true
  })

  return {
    data,
    isLoading,
    error,
    refresh
  }
}
